import {NavItem} from '../shared/components/nav-bar/nav-bar';

export function reportChildrenFor(totalEmployees?: number | null): NonNullable<NavItem['children']> {
  const children: NonNullable<NavItem['children']> = [
    { label: 'Reporte guía 1', route: '/reportes/guia-1' },
  ];

  if (typeof totalEmployees === 'number') {
    if (totalEmployees <= 50) {
      children.push({ label: 'Reporte guía 2', route: '/reportes/guia-2' });
    } else {
      children.push({ label: 'Reporte guía 3', route: '/reportes/guia-3' });
    }
  }
  return children;
}

export function withReportChildren(base: NavItem[], totalEmployees?: number | null): NavItem[] {
  return base.map(item =>
    item.submenuKey === 'REPORTES'
      ? { ...item, children: reportChildrenFor(totalEmployees) }
      : item
  );
}
